export { default } from "./ScreenContent";
